export const excelheader = {
	"合同名称":"name",
	"合同类型":{
		field:"type",
		callback:(value)=>{
			let types = new Map([['1',"班组结算单"],["2","个人结算单"],
			["3","工资预支单"],["4","扫码登记"],
			["5","电子合同"],["6","报销单"],["7","材料预支单"],
			["8","材料领取单"],["9","材料转运单"],["7","工资明细单"],
		])
			return types.get(value)||""
		}
	},
	"合同金额":"price",
	"签署日期":"yiDate",
	"乙方姓名":"yi",
	"乙方电话":"yiPhone",
	"乙方所在工地":"yiWorkPlace",
	"所属班组":"yiBanZhu",
	"是否拨款":{
		callback:(val)=>{
			let {type,isMoneyGive} = val
			if(type != 4){
				return isMoneyGive==1?"已拨款":"未拨款"
			}
			return ""
		}
	},
	"在场情况":{
		callback:(val)=>{
			let {type,yiOuttime} = val
			if(type == 4){
			    return yiOuttime ?"离场":"在场"
			}
			return ""
		}
	}
}